/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Chunky_Walrus_StartleInputs */

const fr_wise_chunky_walrus_startle = /** @type {(inputs: Wise_Chunky_Walrus_StartleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurez les types d'événements auxquels cet utilisateur peut accéder.`)
};

/**

* @param {Wise_Chunky_Walrus_StartleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wise_chunky_walrus_startle = /** @type {((inputs?: Wise_Chunky_Walrus_StartleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Chunky_Walrus_StartleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wise_chunky_walrus_startle(inputs)
});